import { render, staticRenderFns } from "./bottomR2.vue?vue&type=template&id=6ef1ef4e&scoped=true&"
import script from "./bottomR2.vue?vue&type=script&lang=js&"
export * from "./bottomR2.vue?vue&type=script&lang=js&"
import style0 from "./bottomR2.vue?vue&type=style&index=0&id=6ef1ef4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef1ef4e",
  null
  
)

export default component.exports